import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	headingOld: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.customer-service-section.heading',
		defaultMessage: 'Jira Customer Service',
		description: 'Navigation group heading for customer service settings items',
	},
	heading: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.customer-service-section.heading-csm',
		defaultMessage: 'Customer Service Management',
		description: 'Navigation group heading for customer service settings items',
	},
	customerAccessItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.customer-service-section.customer-access-item',
		defaultMessage: 'Customer access',
		description:
			'Navigation item which links to a customer service access configuration settings page',
	},
	formFieldsItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.customer-service-section.form-fields-item',
		defaultMessage: 'Form fields',
		description:
			'Navigation item which links to a customer service form fields configuration settings page',
	},
});
